export function resolveBundleAvailability(sections, state) {
  return sections.every((section) => state[`${section.key}-variant`]?.availableForSale);
}
